import React, { useState, useEffect } from "react";
import NewUserModal from "./NewUserModal";
import { useParams } from "react-router-dom";
import DeleteUserModal from "./DeleteUserModal";
import { Dropdown } from "react-bootstrap";
import FormatDateTime from "../../../../Functions/FormatDate";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { TbUser } from "react-icons/tb";
import NoDataItem from "../NoDataItem";
import ErrorPage from "../../../../Components/ErrorPage";

const MainUsers = () => {
    const { t } = useLanguage()
    const { project_id, db_id } = useParams();
    const [openNewUserModal, setOpenNewUserModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedRecordId, setSelectedRecordId] = useState("")
    const [username, setUserName] = useState("")


    const title_empty_col = "No user accounts available!"
    const subtitle_empty_col = "Create user accounts to grant access to this database. Assign read, write, or admin roles as needed."
    const img_empty = "sqltable"

    const fetchRecords = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await fetch("https://backend.erioon.com/get_db_users", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: sessionStorage.getItem("user_id"),
                    db_id: db_id,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || "Failed to fetch users");
            } else {
                setUsers(data.users || []);
            }
        } catch (err) {
            setError("An unexpected error occurred");
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 800);
        }
    };

    const handleDelete = async (user) => {
        setSelectedRecordId(user._id)
        setShowDeleteModal(true)
        setUserName(user.username)
    };

    useEffect(() => {
        fetchRecords();
    }, [db_id]);

    if (loading) {

    }

    if (loading) {
        return (
            <div className="loading_users_cont"></div>
        )
    } else if (error) {
        return <ErrorPage />;
    }

    return (
        <div className="db_users_cont">

            <div className="db_users_container">
                {loading && <p>Loading users...</p>}
                {error && <p className="error_message">{error}</p>}
                {users.length === 0 ? (
                    <NoDataItem
                        fetchRecords={fetchRecords}
                        title={title_empty_col}
                        subtitle={subtitle_empty_col}
                        item={img_empty}
                        showBtn={true}
                        dbType={"users"}
                    />
                ) : (
                    <div className="users_cont_main">
                        <div className="db_users_container">
                            {users.map((user) => (
                                <div key={user._id} className="api_item">
                                    <p className="table_name"><i><TbUser /></i> {user.username}</p>
                                    <p className="table_desc">{FormatDateTime(user.timestamp)}</p>

                                    <div className="table_item_footer">

                                        <Dropdown>
                                            <div className="property_btn_action_toggle">
                                                <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="custom-dropdown-menu">
                                                    <Dropdown.Item
                                                        className="drop_down_item delete"
                                                        onClick={() => handleDelete(user)}
                                                    >
                                                        <i className="fa-solid fa-trash"></i> {t.delete}
                                                    </Dropdown.Item>

                                                </Dropdown.Menu>
                                            </div>
                                        </Dropdown>
                                        <p className="table_desc">{user.role}</p>

                                    </div>
                                </div>
                            ))}
                            <div className="new_api_item" onClick={() => setOpenNewUserModal(true)}>
                                <i className="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>

                )}
            </div>

            <NewUserModal
                show={openNewUserModal}
                handleClose={() => {
                    setOpenNewUserModal(false);
                }}
                fetchRecords={fetchRecords}
            />
            <DeleteUserModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                recordObject={users.find((user) => user._id === selectedRecordId)}
                fetchRecords={fetchRecords}
                endpoint={"delete_sql_access"}
                record_type={username}
                message="This action CANNOT be undone later. This access will be deleted permanently."
            />
        </div>
    );
};

export default MainUsers;
